import { Search } from 'lucide-react';

/** Placeholder only -- no search implementation exists yet (Part 2 lists it as a structural placeholder for a future milestone). Rendered disabled so it never suggests functionality that isn't there. */
export function AdminCommandSearch() {
  return (
    <button
      type="button"
      disabled
      aria-disabled="true"
      title="Command search — coming in a future admin milestone"
      className="hidden items-center gap-2 rounded-full border border-gray-200 px-3 py-1.5 text-sm text-gray-400 sm:flex"
    >
      <Search className="h-4 w-4" aria-hidden="true" />
      Search
      <kbd className="rounded border border-gray-200 px-1.5 py-0.5 text-xs">⌘K</kbd>
    </button>
  );
}
